import {jsclj, keyword, resolveGoogExport, cljsSet, merge, hash_map} from 'dgetz/tsclj'
import React from 'react'

export function HeightField ({onChange=null, height, height50px=null, quoteHeightInches, removeBorder, updateRootState=null, ...props}) {
    let {height_field} = resolveGoogExport('ladder.agents.dashboard.inputs');
    return height_field(
        jsclj({
            "update-root-state!": updateRootState,
            "on-change": onChange,
            "height": keyword(height),
            "height-50px?": height50px,
            "quote/height-inches": quoteHeightInches,
            "remove-border?": removeBorder}));
}

export function WeightField ({textSize=null, onChange=null, height, height50px=null, quoteWeightPounds, removeBorder, floatingPlaceholder=null, updateRootState=null, ...props}) {
    let {weight_field} = resolveGoogExport('ladder.agents.dashboard.inputs');
    return weight_field(
        jsclj({
            "text-size": textSize,
            "update-root-state!": updateRootState,
            "on-change": onChange,
            "height": keyword(height), "height-50px?": height50px, // yes height not weight
            "quote/weight-pounds": quoteWeightPounds,
            "remove-border": removeBorder,
            "floating-placeholder?": floatingPlaceholder}));
}

interface SingleSelectProps {
    onChange: Function;
    value: string;
    options: {'option-value': string, 'option-label': string, emoji: string}[];
}

export function SingleSelect ({onChange, value, options} : SingleSelectProps) {
    let {single_select} = resolveGoogExport('ladder.agents.dashboard.inputs');
    return single_select(jsclj({"on-change": onChange, value, options}));
}

export function SingleSelectOptions ({grow, onChange, options, ...props}) {
    let {single_select_options} = resolveGoogExport('ladder.agents.dashboard.inputs');
    return single_select_options(
        jsclj({
            "grow?": grow,
            "on-change": onChange,
            options,
            ...props }));
}

export function DobSelect ({removeBorder, height, standaloneQuoterErrorMissingFields, quoteDateOfBirth, onChange,  ...props}) {
        let {dob_select} = resolveGoogExport('ladder.agents.dashboard.inputs');
        return dob_select(jsclj({"remove-border": keyword(removeBorder),
                                 "height": keyword(height),
                                 "on-change": onChange,
                                 "quote/date-of-birth": quoteDateOfBirth,
                                 "standalone-quoter/error-missing-fields": standaloneQuoterErrorMissingFields}));
}

export function StateSelect ({required, height, removeBorder, quoteState, errors, standaloneQuoterErrorMissingFields, onChange}) {
        let {state_select} = resolveGoogExport('ladder.agents.dashboard.inputs');
        return state_select(jsclj({"on-change": onChange,
                                   "quote/state": quoteState,
                                   "errors": errors,
                                   "standalone-quoter/error-missing-fields": standaloneQuoterErrorMissingFields,
                                   "required": required,
                                   "height": height,
                                   "remove-border?": removeBorder}))
}

interface CenteredCheckboxProps {
    name: string;
    outerBorderColor?: string;
    removeBorder: boolean;
    borderColor?: string;
    checked: boolean;
    onChange: Function;
    text: React.ReactNode;
}

export function CenteredCheckbox({name, outerBorderColor, removeBorder, borderColor, checked, onChange, text} : CenteredCheckboxProps) {
    let {centered_checkbox} = resolveGoogExport('ladder.agents.dashboard.inputs');
    return centered_checkbox(
      merge(jsclj({
        "outer-border-color": outerBorderColor,
        "remove-border?": removeBorder,
        "border-color": borderColor,
        "on-change": onChange,
        "name": name,
        "checked": checked}),
      hash_map(keyword('text'), text)))
}

export function QuoterSelect({name, floatingPlaceholder, placeholderText, value, values, onChange, removeBorder, svgPath, fullWidth=null, error=null}) {
    let {quoter_select} = resolveGoogExport('ladder.agents.dashboard.inputs');
    return quoter_select(jsclj({
        "name": name,
        "floating-placeholder?": floatingPlaceholder,
        "placeholder-text": placeholderText,
        "value": value,
        "values": values,
        "on-change": onChange,
        "svg-path": svgPath,
        "error?": error,
        "remove-border?": removeBorder,
        "full-width?": fullWidth
    }))
}

interface InputFieldProps {
    svgPath: string;
    error?: boolean;
    inputDom?: any;
}

export function InputField({svgPath, error, inputDom} : InputFieldProps) {
    let {input_field} = resolveGoogExport('ladder.agents.dashboard.inputs');
    return input_field(hash_map(keyword("svg-path"), svgPath,
        keyword("error?"), error,
        keyword("input-dom"), inputDom))
}
